<div class="view-switcher">
  <button *ngFor="let btn of buttons" [class.active]="btn.id === active" (click)="toggle($event, btn.id)" [disabled]="btn.disabled">
    {{ btn.text }} <span *ngIf="btn?.notification" class="view-switcher--notification">{{ btn?.notification }}</span>
  </button>
</div>
